import { useState, useEffect } from 'react';
import { GlobalData, SecondCollection, Product, ProductMetafields } from '../../../types';
import { redirectTo404 } from '../../../utils/redirectTo404';

interface UseProductDataProps {
  data: GlobalData[];
  firstCollectionHandle: string | null;
  secondCollectionHandle: string | null;
  productHandle: string | null;
}

export const useProductData = ({
  data,
  firstCollectionHandle,
  secondCollectionHandle,
  productHandle,
}: UseProductDataProps) => {
  const [collectionData, setCollectionData] = useState<GlobalData>();
  const [secondCollectionData, setSecondCollectionData] = useState<SecondCollection>();
  const [productData, setProductData] = useState<{ product: Product; product_metafields: ProductMetafields }>();
  const [options, setOptions] = useState<string[]>([]);
  const [variants, setVariants] = useState<string[]>([]);

  const collectionOtherData = data.find((d) => d.first_collection.handle === 'first_other');

  useEffect(() => {
    if (!firstCollectionHandle || !secondCollectionHandle || !productHandle) {
      redirectTo404();
      return;
    }

    const collection = data.find((d) => d.first_collection.handle === firstCollectionHandle);

    if (!collection) {
      redirectTo404();
      return;
    }

    const secondCollection =
      secondCollectionHandle === 'second_other'
        ? collectionOtherData?.second_collections[0]
        : collection.second_collections.find((sc) => sc.second_collection.handle === secondCollectionHandle);
    if (!secondCollection) {
      redirectTo404();
      return;
    }

    const product =
      productHandle === 'product_other'
        ? collectionOtherData?.second_collections[0].products[0]
        : secondCollection.products.find((p) => p.product.handle === productHandle);

    if (!product) {
      redirectTo404();
      return;
    }

    const opts: string[] = [];
    const vars: string[] = [];

    product.product.options.forEach((optionData, optionIndex) => {
      const optionName = optionData;
      const optionValue = product.product.variants[0].options[optionIndex];
      opts.push(optionName);
      vars.push(optionValue);
    });

    setCollectionData(collection);
    setSecondCollectionData(secondCollection);
    setProductData(product);
    setOptions(opts);
    setVariants(vars);
  }, [data, firstCollectionHandle, secondCollectionHandle, productHandle]);

  return {
    collectionData,
    secondCollectionData,
    productData,
    options,
    variants,
  };
};
